export const getErrorMessage = (error: unknown) =>
  error instanceof Error ? error.message : "Erro desconhecido";

export const getAuthErrorPath = (errorMessage: string) => {
  if (errorMessage.includes("AADB2C90151")) return "/Response/AADB2C90151";
  if (errorMessage.includes("AADB2C90157")) return "/Response/AADB2C90157";

  return "/Response/Error";
};
